<template>
  <div>
    <div class="appointment-table table-common">
      <el-table :data="allAppointData" style="width: 100%">
        <el-table-column label="序号" width="82">
          <template slot-scope="scope">
            <span>{{ (scope.$index+1)+(pageObj.currPage - 1)*pageObj.pageRowNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预约详情" width="900">
          <template slot-scope="scope">
            <ul>
              <li>
                <p>预约流水号</p>
                <p>{{scope.row.reserveSeq}}</p>
              </li>
              <li>
                <p>预约时段</p>
                <p>{{scope.row.reserveStartTime}}-{{scope.row.reserveEndTime}}</p>
              </li>
              <li>
                <p>预约日期</p>
                <p>{{scope.row.reserveDate}}</p>
              </li>
              <li>
                <p>业务名称</p>
                <p :title="scope.row.busiName">{{scope.row.busiName}}</p>
              </li>
            </ul>
            <ul>
              <li>
                <p>姓名</p>
                <p :title="scope.row.userName">{{scope.row.userName}}</p>
              </li>
              <li>
                <p>手机号</p>
                <p>{{scope.row.mobilePhone}}</p>
              </li>
              <li>
                <p>身份证</p>
                <p>{{scope.row.paperCode}}</p>
              </li>
              <li>
                <p>企业名称</p>
                <p :title="scope.row.comName">{{scope.row.comName}}</p>
              </li>
            </ul>
          </template>
        </el-table-column>

        <el-table-column label="预约状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.overdue == 1&&scope.row.isCancel !=1">已过期</span>
            <span v-if="scope.row.isCancel == 1&&scope.row.overdue !=1">已取消</span>
            <span v-if="scope.row.isCancel != 1&&scope.row.overdue !=1">预约成功</span>
            <span v-if="scope.row.isCancel == 1&&scope.row.overdue == 1">已取消/过期</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width>
          <template slot-scope="scope">
            <a
              v-if="scope.row.isCancel==1"
              class="cancel"
              @click="handleAppoint(scope.row.isCancel,scope.row.reserveSeq,scope.row.paperCode)"
            >删除预约</a>
            <a
              v-else-if="scope.row.overdue==1"
              class="cancel"
              @click="handleAppoint(scope.row.overdue,scope.row.reserveSeq,scope.row.paperCode)"
            >删除预约</a>
            <a v-else @click="handleAppoint('',scope.row.reserveSeq,scope.row.paperCode)">取消预约</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <p class="total-items">共{{pageObj.totalRow}}条事项</p>
    <div class="page-content">
      <el-pagination
        background
        @current-change="changePage"
        :current-page="pageObj.currPage"
        :page-size.sync="pageObj.pageRowNum"
        layout="prev, pager, next"
        :total="pageObj.totalRow"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { Message, MessageBox } from 'element-ui'
export default {
  props: ['allAppointData', 'pageObj'],
  data () {
    return {}
  },

  filters: {
    getIsTake (val) {
      let isTake = val
      switch (val) {
        case 0:
          isTake = '未取号'
          break
        case 1:
          isTake = '已取号'
          break
        case 2:
          isTake = '已叫号'
          break
        case 3:
          isTake = '办理完结'
          break
        default:
          break
      }
      return isTake
    }
  },
  methods: {
    handleAppoint (type, reserveSeq, deleteCode) {
      // 删除预约
      // console.log(deleteCode);
      if (type == 1) {
        MessageBox.confirm('预约办件将永久删除，是否确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$emit('deletelOrder', reserveSeq, deleteCode)
          })
          .catch(() => {
            Message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        // 取消预约
        MessageBox.confirm('取消预约办件，是否确认取消？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$emit('cancelOrder', reserveSeq, deleteCode)
          })
          .catch(() => {
            Message({
              type: 'info',
              message: '已取消'
            })
          })
      }
    },
    changePage (val) {
      this.$emit('clickPages', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.appointment-table {
  margin-top: 26px;
  border: 1px solid rgba(221, 221, 221, 1);
  ::v-deep thead tr th {
    &:first-of-type {
      padding-left: 10px;
    }
    &:nth-of-type(4) {
      text-align: right;
      padding-right: 30px;
    }
    div {
      font-weight: 800;
    }
  }
  ::v-deep tbody tr td {
    &:nth-of-type(1) {
      padding-left: 10px;
    }
    &:nth-of-type(2) {
      ul {
        width: 348px;
        &:first-of-type {
          float: left;
          margin-right: 30px;
        }
        &:last-of-type {
          float: left;
        }
      }
      p {
        font-family: "PingFangSC-Regular";
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        &:first-of-type {
          float: left;
          width: 70px;
          color: #999999;
          padding-right: 8px;
        }
        &:last-of-type {
          float: right;
          width: 270px;
        }
      }
    }
    &:last-of-type {
      .cell a {
        padding-top: 10px;
        cursor: pointer;
        width: 88px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        background: $main-color;
        border-radius: 3px;
        &.cancel {
          background: #ffffff;
          border: 1px solid $main-color;
          border-radius: 3px;
          color: $main-color;
        }
      }
    }
  }
}
.total-items {
  text-align: right;
  margin: 20px 0 90px 0;
  font-family: "PingFangSC-Regular";
  font-size: 14px;
  color: #999999;
  text-align: right;
}
.page-content {
  text-align: right;
  ::v-deep ul li {
    // color: #254CCA !important;
    // background: #3E97DF 100% !important;
  }
}
</style>
